module.exports = "//public.getcloudapp.com/packs/media/images/icons-notifications-d3b69c95afb2aeddf077a8d0008a018a.svg";